import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { getToken, removeToken } from "Session";

const apiCarteira = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_API_CARTEIRA_URL,
});

apiCarteira.interceptors.request.use((config: AxiosRequestConfig) => {
  if (config.url !== "/usuarios/login") {
    const token = getToken();
    if (token) {
      if (config.headers) config.headers.Authorization = `Basic ${token}`;
    }
  }
  return config;
});

apiCarteira.interceptors.response.use(
  (res: AxiosRequestConfig) => {
    return res;
  },
  (error: AxiosError) => {
    if (
      error.config.url !== "/usuarios/login" &&
      401 === error.response?.status
    ) {
      removeToken();
      window.location.href = "/login";
      return Promise.reject(error);
    } else if (
      error.config.url !== "/usuarios/login" &&
      403 === error.response?.status
    ) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default apiCarteira;
